<template>
  <page-500 v-if="$offline" :back="backFromOffline" :message="$t('shared.youAreOffline')"/>
  <div v-else>
    <progress-bar></progress-bar>
    <notifications></notifications>

    
    <pub v-if="isPublic"></pub>
    <prnt v-else-if="isPrint"/>
    <cp v-else></cp>
  </div>
</template>

<script>
import * as types from '@/store/types'

import cp from './CP'
import pub from './Public'
import Prnt from './Print'

import favicon from '@/../public/favicon'
import { ProgressBar, Notifications } from './core'
import { Page500 } from '@/components/shared'

import {mapState} from 'vuex'

import { guard as authGuard } from '@/auth'

export default {
  name: 'root',
  components: {
    cp,
    pub,
    Prnt,
    ProgressBar,
    Notifications,
    Page500
  },
  metaInfo () {
    favicon.metas.forEach(m => {
      if (m.content === 'APP_TITLE')
        m.content = this.$t('branding.appName')
    })

    return {
      title: this.$t('branding.appTagline'),
      titleTemplate: `%s | ${this.$t('branding.appName')}`,
      htmlAttrs: {
        dir: this.direction
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { hid: 'description', name: 'description', content: this.$t('branding.appTagline') },
        ...favicon.metas
      ],
      link: [
        ...favicon.links
      ]
    }
  },
  computed: {
    ...mapState(['$offline', '$account']),
    direction () {
      return this.$t('direction')
    },
    isPublic () {
      return this.$route.meta && this.$route.meta.public
    },
    isPrint () {
      return this.$route.meta && this.$route.meta.print
    }
  },
  mounted () {
    authGuard(this.$route.path, this.$route.meta && this.$route.meta.auth, path => {
      if (path)
        this.$nextTick(() => this.$router.push(path))
    })
  },
  methods: {
    backFromOffline () {
      this.$store.commit(types.SET_OFFLINE, false)
    }
  }
}
</script>
